import { render } from "./OutroPopup.vue?vue&type=template&id=14f08809&scoped=true"
import script from "./OutroPopup.vue?vue&type=script&lang=js"
export * from "./OutroPopup.vue?vue&type=script&lang=js"

import "./OutroPopup.vue?vue&type=style&index=0&id=14f08809&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f08809"]])

export default __exports__